import { render, staticRenderFns } from "./shouruCQ.vue?vue&type=template&id=af27ea82&scoped=true&"
import script from "./shouruCQ.vue?vue&type=script&lang=js&"
export * from "./shouruCQ.vue?vue&type=script&lang=js&"
import style0 from "./shouruCQ.vue?vue&type=style&index=0&id=af27ea82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af27ea82",
  null
  
)

export default component.exports